import Header from "../components/Header";
import { HiOutlineLightningBolt } from "react-icons/hi";
import { FaCar, FaUser } from "react-icons/fa";
import { BsSend } from "react-icons/bs";
import Footer from "../components/Footer";
import { useEffect, useState } from "react";
import { id_firebase } from "../content-site";
import { firestore } from "../firebase-config";
import { collection, doc, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { FiDollarSign } from "react-icons/fi";
import { RiShakeHandsLine } from "react-icons/ri";

export default function Venda() {
    const [revenda, setRevenda] = useState({});
    const [marcas, setMarcas] = useState([]); 
    const [marca, setMarca] = useState('');
    const [modelo, setModelo] = useState('');
    const [versao, setVersao] = useState('');
    const [cor, setCor] = useState('');
    const [km, setKm] = useState('');
    const [placa, setPlaca] = useState('');
    const [anoModelo, setAnoModelo] = useState('');
    const [opcionais, setOpcionais] = useState('');
    const [enviado, setEnviado] = useState(false);
    const [msgEnviado, setMsgEnviado] = useState('');
    const [nome, setNome] = useState('');
    const [telefone, setTelefone] = useState('');
    const [email, setEmail] = useState('');
    const [dadosFinanciamento,] = useState('');
    const [errors, setErrors] = useState({});

    useEffect(() => {
        window.scrollTo(0, 0);

        import("firebase/firestore").then(({ getDoc }) => {
            const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
            getDoc(revendaRef).then((docSnap) => {
                if (docSnap.exists()) {
                    setRevenda(docSnap.data());
                }
            });
        });

        const q = query(
            collection(doc(collection(firestore, "revenda"), id_firebase), "veiculos"),
            where("veremovido", "==", 0),
            where("vevendido", "==", 0),
            orderBy("updated_at", "desc")
        );

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const items = [];
            querySnapshot.forEach((doc) => {
                const document = doc.data();
                document.id = doc.id;
                if (document["veexibir_site"] !== false) {
                    items.push(document);
                }
            });

            const marcasUnicas = [
                ...new Set(items.map(item => item.vefipe_marca).filter(Boolean))
            ];
            setMarcas(marcasUnicas);
        });

        return () => unsubscribe();
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!validateForm()) return;
        setEnviado(true);
        setMsgEnviado('Enviando mensagem...');

        let mensagem = `<strong>Dados do financiamento:</strong><br><br>${dadosFinanciamento}`;
        mensagem += `<br><br><strong>Dados pessoais</strong><br>`;
        mensagem += `<br>Nome: ${nome}`;
        mensagem += `<br>Telefone: ${telefone}`;
        mensagem += `<br>Email: ${email}`;

        mensagem += `<br>Marca: ${marca}`;
        mensagem += `<br>Modelo: ${modelo}`;
        mensagem += `<br>Versão: ${versao}`;
        mensagem += `<br>Cor: ${cor}`;
        mensagem += `<br>KM: ${km}`;
        mensagem += `<br>Placa: ${placa}`;
        mensagem += `<br>Ano/Modelo: ${anoModelo}`;
        mensagem += `<br>Opcionais: ${opcionais}`;

        fetch('https://us-central1-intermedio-1513801146022.cloudfunctions.net/enviarEmail', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                remetente: `Contato ${revenda.penome_fantasia}<${revenda.peemail}>`,
                assunto: `Avaliação de venda de veículo - Site ${revenda.penome_fantasia}`,
                destinatarios: revenda.peemail,
                corpo: mensagem,
                corpoHtml: mensagem,
            }),
        })
            .then((res) => {
                setMsgEnviado('E-Mail enviado com sucesso, em breve você receberá um retorno da nossa equipe.');
                setTimeout(() => setEnviado(false), 5000);
                resetForm();
            })
            .catch((error) => {
                setMsgEnviado('Erro ao enviar e-mail, tentar novamente mais tarde');
                setTimeout(() => setEnviado(false), 5000);
                console.error('Erro ao enviar e-mail:', error);
            });
    };

    const resetForm = () => {
        setNome('');
        setTelefone('');
        setEmail('');
        setMarca('');
        setModelo('');
        setVersao('');
        setCor('');
        setKm('');
        setPlaca('');
        setAnoModelo('');
        setOpcionais('');
    };

    const validateForm = () => {
        const newErrors = {};
        if (!nome.trim()) newErrors.nome = "Nome obrigatório.";
        if (!telefone.trim()) newErrors.telefone = "Telefone obrigatório.";
        if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) newErrors.email = "E-mail inválido.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    return (
        <div>
            <Header />

            <div className="relative h-[350px] w-full">
                <img
                    src="/banner.png"
                    alt="Banner Ferrari Veículos"
                    className="object-cover w-full h-full"
                />

                <div className="absolute inset-0 bg-black/50" />

                <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-10">
                    <h1 className="text-2xl md:text-6xl font-bold mt-20">Solicite uma avaliação do seu veículo</h1>
                    <p className="text-lg font-semibold mt-2">Envie para nossa equipe os dados do seu veículo para fazermos uma proposta. Em breve retornaremos o contato.</p>
                </div>
            </div>

            <div className="flex flex-col justify-center items-center py-10 mt-20 min-h-screen">
                <form onSubmit={handleSubmit} className="max-w-3xl w-full mx-auto p-6 bg-secondary rounded-lg shadow">
                    <div className="flex flex-col md:flex-row justify-center items-stretch text-center mb-10 md:mb-22 gap-6 md:gap-20">
                        <div className="flex flex-col items-center flex-1">
                            <div className="bg-[#EF9D0F] text-white p-8 text-4xl rounded-3xl">
                                <HiOutlineLightningBolt />
                            </div>
                            <h2 className="text-yellow-600 text-xl font-semibold mt-4">Avaliação Rápida</h2>
                            <p className="text-white">Resposta em até 24 horas</p>
                        </div>

                        <div className="flex flex-col items-center flex-1">
                            <div className="bg-[#EF9D0F] text-white p-8 text-4xl rounded-3xl">
                                <FiDollarSign />
                            </div>
                            <h2 className="text-yellow-600 text-xl font-semibold mt-4">Melhor Preço</h2>
                            <p className="text-white">Avaliação justa e competitiva</p>
                        </div>

                        <div className="flex flex-col items-center flex-1">
                            <div className="bg-[#EF9D0F] text-white p-8 text-4xl rounded-3xl">
                                <RiShakeHandsLine />
                            </div>
                            <h2 className="text-yellow-600 text-xl font-semibold mt-4">Processo Simples</h2>
                            <p className="text-white">Sem burocracia desnecessária</p>
                        </div>
                    </div>
                    <div className="flex items-center gap-2 text-yellow-600 font-bold text-lg mb-4">
                        <div className="bg-yellow-200 p-2 rounded-lg">
                            <FaUser className="text-2xl" />
                        </div>
                        <h2>DADOS PESSOAIS</h2>
                    </div>
                    <div className="mt-4">

                        <div className="flex flex-col mb-4">
                            <label className="text-sm font-medium mb-1">Nome Completo *</label>
                            <input
                                type="text"
                                placeholder="Digite seu nome completo"
                                className="border border-neutral-300  rounded-lg p-3 outline-none focus:ring-2 focus:ring-yellow-500"
                                value={nome}
                                onChange={e => setNome(e.target.value)}
                            />
                        </div>

                        <div className="flex flex-col mb-4">
                            <label className="text-sm font-medium mb-1">Telefone *</label>
                            <input
                                type="text"
                                placeholder="(00) 00000-0000"
                                className={`border ${errors.telefone ? 'border-yellow-500' : 'border-neutral-300'} rounded-lg p-3 outline-none focus:ring-2 focus:ring-yellow-500`}
                                value={telefone}
                                onChange={e => setTelefone(e.target.value)}
                            />
                            {errors.telefone && <span className="text-yellow-500 text-xs">{errors.telefone}</span>}
                        </div>

                        <div className="flex flex-col mb-4">
                            <label className="text-sm font-medium mb-1">E-mail *</label>
                            <input
                                type="email"
                                placeholder="Digite seu e-mail"
                                className={`border ${errors.email ? 'border-yellow-500' : 'border-neutral-300'} rounded-lg p-3 outline-none focus:ring-2 focus:ring-yellow-500`}
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                            />
                            {errors.email && <span className="text-yellow-500 text-xs">{errors.email}</span>}
                        </div>
                    </div>

                    <div className="flex items-center gap-2 text-yellow-600 font-bold text-lg mb-4">
                        <div className="bg-yellow-200 p-2 rounded-lg">
                            <FaCar className="text-2xl" />
                        </div>
                        <h2>DADOS DO VEÍCULO</h2>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="flex flex-col">
                            <label className="text-sm font-medium mb-1">Marca *</label>
                            <select
                                className="border border-neutral-300 rounded-lg p-3 outline-none focus:ring-2 focus:ring-yellow-500"
                                value={marca}
                                onChange={e => setMarca(e.target.value)}
                            >
                                <option value="">Selecione a marca</option>
                                {marcas.map((m, idx) => (
                                    <option key={idx} value={m}>{m}</option>
                                ))}
                            </select>
                        </div>

                        <div className="flex flex-col">
                            <label className="text-sm font-medium mb-1">Modelo *</label>
                            <input
                                type="text"
                                placeholder="Ex: Civic, Corolla, Golf"
                                className="border border-neutral-300 rounded-lg p-3 outline-none focus:ring-2 focus:ring-yellow-500"
                                value={modelo}
                                onChange={e => setModelo(e.target.value)}
                            />
                        </div>

                        <div className="flex flex-col">
                            <label className="text-sm font-medium mb-1">Versão</label>
                            <input
                                type="text"
                                placeholder="Ex: EX, XLS, Highline"
                                className="border border-neutral-300 rounded-lg p-3 outline-none focus:ring-2 focus:ring-yellow-500"
                                value={versao}
                                onChange={e => setVersao(e.target.value)}
                            />
                        </div>

                        <div className="flex flex-col">
                            <label className="text-sm font-medium mb-1">Cor</label>
                            <input
                                type="text"
                                placeholder="Ex: Branco, Prata, Preto"
                                className="border border-neutral-300 rounded-lg p-3 outline-none focus:ring-2 focus:ring-yellow-500"
                                value={cor}
                                onChange={e => setCor(e.target.value)}
                            />
                        </div>

                        <div className="flex flex-col">
                            <label className="text-sm font-medium mb-1">KM *</label>
                            <input
                                type="number"
                                placeholder="Ex: 50000"
                                className="border border-neutral-300 rounded-lg p-3 outline-none focus:ring-2 focus:ring-yellow-500"
                                value={km}
                                onChange={e => setKm(e.target.value)}
                            />
                        </div>

                        <div className="flex flex-col">
                            <label className="text-sm font-medium mb-1">Placa</label>
                            <input
                                type="text"
                                placeholder="ABC-1234"
                                className="border border-neutral-300 rounded-lg p-3 outline-none focus:ring-2 focus:ring-yellow-500"
                                value={placa}
                                onChange={e => setPlaca(e.target.value)}
                            />
                        </div>

                        <div className="flex flex-col md:col-span-2">
                            <label className="text-sm font-medium mb-1">Ano/Modelo *</label>
                            <input
                                type="text"
                                placeholder="Ex: 2020/2021"
                                className="border border-neutral-300 rounded-lg p-3 outline-none focus:ring-2 focus:ring-yellow-500"
                                value={anoModelo}
                                onChange={e => setAnoModelo(e.target.value)}
                            />
                        </div>

                        <div className="flex flex-col md:col-span-2">
                            <label className="text-sm font-medium mb-1">Opcionais</label>
                            <textarea
                                placeholder="Descreva os opcionais do veículo: ar condicionado, direção hidráulica, vidros elétricos, alarme, som, rodas de liga, etc."
                                className="border border-neutral-300 rounded-lg p-3 outline-none focus:ring-2 focus:ring-yellow-500 resize-none"
                                rows={4}
                                value={opcionais}
                                onChange={e => setOpcionais(e.target.value)}
                            />
                        </div>
                    </div>

                    <button type="submit" className="flex items-center justify-center gap-4 text-white bg-[#DC2626] font-bold text-xl px-20 py-4 rounded-lg mx-auto mt-4">
                        <BsSend />
                        ENVIAR DADOS
                    </button>
                    {
                        enviado &&
                        <blockquote>
                            <p><em>{msgEnviado}</em></p>
                        </blockquote>
                    }
                </form>
            </div >

            <Footer />
        </div >
    );
}